<template>
  <div id="copyright-documents-dialog">
    <ipub-model title="Preview Manuscript"
                width="1000px"
                class="copyright-documents"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="false">
      <div class="mar-b-20">
        <div class="ipub-title-tab ipub-title ipub-h3 mar-b-10">
          <a @click="()=>{step1 = !step1}"
             class="">
            Manuscript Information
            <ipub-icon :class="['mar-l-10 rotate',step1?'rotate-180':'']"
                       type="iconArrow" />
          </a>
          <div class="ipub-p2 content-color">
            <a @click="goToPage('step1?id='+manuscript.id)">
              <ipub-icon style="font-size:16px"
                         type="iconEdit" />
            </a>
          </div>
        </div>
        <div v-if="step1"
             class="ipub-title-tab-part ipub-p2">
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Journal
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.journal?manuscript.journal.name:'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Article Type
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.type&&manuscript.details.type.name||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Title
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.title||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Section
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.section&&manuscript.details.section.name||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Special Issue
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details && manuscript.details.special && manuscript.details.special.titleText || '--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Abstract
            </ipub-col>
            <ipub-col :span="10">
              {{manuscript.details&&manuscript.details.summary||'--'}}
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Keywords
            </ipub-col>
            <ipub-col :span="10">
              <template v-if="manuscript && manuscript.details &&manuscript.details.keyword">
                {{manuscript.details.keyword}}
              </template>
              <template v-else>--</template>
              <!-- <ipub-label :style="{margin: '5px 0 5px 8px'}"
                          v-for="(item, index) in manuscript.details.keyword.split(',')"
                          :key="'specialIssue.keywords'+index"
                          size="small"
                          circle>{{item}}</ipub-label> -->
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Funding
            </ipub-col>
            <ipub-col :span="10">
              <template v-if="manuscript && manuscript.foundationList &&manuscript.foundationList.length>0">
                <div v-for="item in manuscript.foundationList"
                     :key="item.id">{{item.name}} <template v-if="item.code">({{item.code}})</template></div>
              </template>
              <template v-else>--</template>
            </ipub-col>
          </ipub-row>
          <ipub-row :gutter="[30, 20]">
            <ipub-col class="fw-bd "
                      :span="2">
              Discount
            </ipub-col>
            <ipub-col :span="10">
              <template v-if="manuscript && manuscript.discountDetailList &&manuscript.discountDetailList.length>0">
                <font>{{manuscript.__diacountTotal}} USD off</font>
              </template>
              <template v-else>--</template>
            </ipub-col>
          </ipub-row>
        </div>
      </div>
      <div class="mar-b-20">
        <div class="ipub-title-tab ipub-title ipub-h3 mar-b-10">
          <a @click="()=>{step2 = !step2}">
            Author Information
            <ipub-icon :class="['mar-l-10 rotate',step2?'rotate-180':'']"
                       type="iconArrow" />
          </a>
          <div class="ipub-p2">
            <a @click="goToPage('step2?id='+manuscript.id)">
              <ipub-icon style="font-size:16px"
                         type="iconEdit" />
            </a>
          </div>
        </div>
        <div v-if="step2"
             class="ipub-title-tab-part ipub-p2">
          <div class="copyright-documents-block-content-list border-top"
               v-for="item in manuscript.authorList"
               :key="item.id">
            <div class="mar-b-10">#{{item.seq}} {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}
              <ipub-label v-if="item.submited"
                          size="small"
                          class="mar-l-20"
                          type="theme">
                Submitted Author
              </ipub-label>
              <ipub-label v-if="item.firsted"
                          size="small"
                          class="mar-l-10"
                          type="theme">
                First Author
              </ipub-label>
              <ipub-label v-if="item.corresponded"
                          size="small"
                          class="mar-l-10"
                          type="theme">
                Correspondence Author
              </ipub-label>
            </div>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                Email
              </ipub-col>
              <ipub-col :span="10">
                {{item.email}}
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                Country / Terriory
              </ipub-col>
              <ipub-col :span="10">
                {{country[item.countryCode]}}
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                <ipub-icon type="iconORCID"
                           style="color:#a6ce39"></ipub-icon>
                ORCID
              </ipub-col>
              <ipub-col :span="10">
                {{item.orcid}}
              </ipub-col>
            </ipub-row>
            <ipub-row :gutter="[30, 12]">
              <ipub-col class="fw-bd "
                        :span="2">
                Affiliation(s)
              </ipub-col>
              <ipub-col :span="10">
                {{item.affiliation}}
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <div class="mar-b-20 line-h-40">
        <div class="ipub-title-tab ipub-title ipub-h3 mar-b-10">
          <a @click="()=>{step4 = !step4}">
            Manuscript Files
            <ipub-icon :class="['mar-l-10 rotate',step4?'rotate-180':'']"
                       type="iconArrow" />
          </a>
          <div class="ipub-p2">
            <a @click="goToPage('step3?id='+manuscript.id)">
              <ipub-icon style="font-size:16px"
                         type="iconEdit" />
            </a>
          </div>
        </div>
        <div v-if="step4"
             class="ipub-title-tab-part ipub-p2">
          <div class="mar-b-12"
               v-for="item in manuscript.fileList"
               :key="item.id">
            <ipub-row :gutter="30">
              <ipub-col class="fw-bd "
                        :span="3">
                {{item.item?item.item.typeName:'--'}}
              </ipub-col>
              <ipub-col :span="9">
                <ipub-label style="margin: 0 16px 0 0;"><a class="link-color"
                     @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                     target="_blank">{{item.name}}</a>
                  <ipub-icon v-if="item.loading"
                             class="mar-l-10"
                             type="loading" />
                  <ipub-icon v-else-if="item.progress === 100"
                             @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                             class="mar-l-10 ipub-cursor-pointer success-color"
                             type="iconAble" />
                  <ipub-icon v-else
                             @click="downloadMfile(`${domain}/${item.path}`, item.name, item)"
                             class="mar-l-10 ipub-cursor-pointer link-color"
                             type="iconDownload1" />
                </ipub-label>
                <div class="ipub-block_font-downloading">
                  <div class="ipub-block_font-downloading-content"
                       v-if="item.loading"
                       :style="{width:item.progress+'%'}"></div>
                </div>
              </ipub-col>
            </ipub-row>
          </div>
        </div>
      </div>
      <div class="copyright-documents-block">
        <div class="ipub-title-tab ipub-title ipub-h3 mar-b-10">
          <a @click="()=>{step3 = !step3}">
            Suggest & Oppose Reviewers
            <ipub-icon :class="['mar-l-10 rotate',step3?'rotate-180':'']"
                       type="iconArrow" />
          </a>
          <div class="ipub-p2">
            <a @click="goToPage('step4?id='+manuscript.id)">
              <ipub-icon style="font-size:16px"
                         type="iconEdit" />
            </a>
          </div>
        </div>
        <div v-if="step3"
             class="ipub-title-tab-part">
          <div class="flex">
            <div class="fw-bd"
                 v-if="manuscript.reviewerList && manuscript.reviewerList.length>0">Suggest Reviewer</div>
            <div class="mar-l-20">
              <template v-for="(item,index) in manuscript.reviewerList">
                <div v-if="item.type==='SUGGEST'"
                     :key="item.id+index"
                     class="mar-b-12">
                  <div class="ipub-p2">{{item.firstName}} {{item.lastName}} ({{item.email}})</div>
                  <span class="ipub-p2">{{item.affiliation}}</span>
                </div>
              </template>
            </div>
          </div>
          <div class="flex">
            <div class="fw-bd"
                 v-if="manuscript.reviewerList && manuscript.reviewerList.length>0">Oppose Reviewer</div>
            <div class="mar-l-20">
              <template v-for="(item,index) in manuscript.reviewerList">
                <div v-if="item.type==='OPPOSE'"
                     :key="item.id+index"
                     class="mar-b-12">
                  <div class="ipub-p2">{{item.firstName}} {{item.lastName}} ({{item.email}})</div>
                  <span class="ipub-p2">{{item.affiliation}}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      step1: true,
      step2: true,
      step4: true,
      step3: true,
      download: help.download
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      manuscript: 'getManuscript',
      journalId: 'getJournalId',
      title: 'getTitle',
      domain: 'getDomain',
      country: 'getCountry',
    })
  },
  watch: {
    isVisable (val) {
      if (val) {
        let disTotal = 0
        if (this.manuscript.discountDetailList && this.manuscript.discountDetailList.length > 0) {
          this.manuscript.discountDetailList.forEach(ele => {
            disTotal += ele['discount']
          })
          this.manuscript.__diacountTotal = disTotal
        }
      }
    }
  },
  methods: {
    downloadMfile (url, name, val) {
      this.$set(val, 'loading', true)
      this.download(url, name, (progress) => {
        this.$set(val, 'progress', progress)
        if (progress === 100) {
          this.$set(val, 'loading', false)
          setTimeout(() => {
            this.$set(val, 'progress', 0)
          }, 2000);
        }
      })

    },
    cancel () {
      this.$emit('cancel')
    },
    goToPage (val) {
      this.$emit('goToPage', val)
    }
  }
}
</script>

<style lang="scss" scoped>
#copyright-documents-dialog {
  .border-top {
    border-top: 1px solid $line_color;
    padding: 10px 0;
    &:nth-child(1) {
      border-top: transparent;
    }
  }
  .ipub-title {
    color: $content_color;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .copyright-documents {
    &-block {
      // @include ipub-shadow;
      // padding: 16px;
      &-content {
        margin-top: 20px;
        &-list {
          // border-bottom: 1px solid $line_color;
          margin-bottom: 20px;
          &:last-child {
            //   border-bottom: none;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .ipub-block_font-downloading {
    width: 153px;
    height: 5px;
    &-content {
      width: 0;
      height: 100%;
      background: $main_color_l;
      transition: 0.3s all;
    }
  }
}
</style>
